module.exports = __webpack_public_path__ + "static/media/rfid5.366f5299.jpg";